export function getdata() {
	var obj = {
			tableData: [],
			mblist: [{
				value: '通知名称',
				label: '通知名称'
				}, {
					value: '通知模板',
					label: '通知模板'
				}, {
					value: '关联指标',
					label: '关联指标'
				}, {
					value: '通知对象',
					label: '通知对象'
				}, {
					value: '通知频率',
					label: '通知频率'
				}, {
					value: '通知时间',
					label: '通知时间'
				}, {
					value: '通知停止数据',
					label: '通知停止数据'
				}, {
					value: '指标编号',
					label: '指标编号'
				}, {
					value: '指标大类',
					label: '指标大类'
				}, {
					value: '指标类型',
					label: '指标类型'
				}, {
					value: '指标名称',
					label: '指标名称'
				}, {
					value: '税表名称',
					label: '税表名称'
				}, {
					value: '预警值',
					label: '预警值'
				}, {
					value: '当前值',
					label: '当前值'
				}, {
					value: '是否超过预警值',
					label: '是否超过预警值'
				}, {
					value: '最新更新时间',
					label: '最新更新时间'
				}, {
					value: '是否启用',
					label: '是否启用'
				}, {
					value: '模板名称',
					label: '模板名称'
				}, {
					value: '通知方式',
					label: '通知方式'
				}, {
					value: '公司名称',
					label: '公司名称'
				}, {
					value: '公司编号',
					label: '公司编号'
				}],
				options: [],
			searchdata: {
				noticeTemplateName: '',
				noticeType: '',
			},
		searchlist: [{
			prop: "noticeTemplateName",
			label: '模板名称',
			type: "input"
		}, {
			prop: "noticeType",
			label: '通知方式',
			type: "select",
			selectval: [
			// 	{
			// 	label: "短信",
			// 	value: 1
			// }, 
			{
				label: "邮件",
				value: 2
			},
			// {
			// 	label: "钉钉",
			// 	value: 3
			// },
			]

		}],
		headData: [{
				title: "模板名称",
				prop: "noticeTemplateName",
				width: 80,
				custom: true
			}, {
				title: "通知方式",
				prop: "noticeType",
				width: 80,
				custom: true
			}, {
				title: "操作",
				prop: "cz",
				width: "200",
				fixed: "right",
				custom: true
			},

		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}

}
return obj
}
